import React from 'react';
import { experiences } from '../data/mock';
import { CheckCircle, Star } from 'lucide-react';

const Experiences = () => {
  return (
    <section id="experiences" className="py-24 px-6 ivory-bg">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-font text-5xl md:text-6xl font-bold text-black mb-4">
            Our Experiences
          </h2>
          <div className="w-24 h-1 gold-bg mx-auto mb-6"></div>
          <p className="body-font text-xl text-gray-700 max-w-3xl mx-auto">
            Signature entertainment concepts designed to elevate your conference into an unforgettable event
          </p>
        </div>

        {/* Experience Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {experiences.map((exp, index) => (
            <div 
              key={exp.id} 
              className="experience-card group bg-white rounded-sm overflow-hidden shadow-lg hover:shadow-2xl transition-all border border-gray-200 relative"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Tag Badge */}
              {exp.tag && (
                <div className="absolute top-4 right-4 z-10 gold-bg px-3 py-1 rounded-sm flex items-center gap-1">
                  <Star className="text-black" size={14} fill="black" />
                  <span className="body-font text-xs font-semibold text-black">{exp.tag}</span>
                </div>
              )}

              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={exp.image} 
                  alt={exp.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-40 transition-opacity"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="heading-font text-2xl font-bold text-black mb-3">
                  {exp.title}
                </h3>
                <p className="body-font text-gray-700 mb-4 leading-relaxed text-sm">
                  {exp.description}
                </p>

                {/* Highlights */}
                <div className="space-y-1.5">
                  {exp.highlights.map((highlight, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <CheckCircle className="gold-accent flex-shrink-0" size={16} />
                      <span className="body-font text-xs text-gray-600">{highlight}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experiences;
